function menuItem(theme) {
  const { palette, borders, transitions } = theme;

  const { secondary, light, primary } = palette;
  const { borderRadius } = borders;

  return {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    color: secondary.main,
    py: 1,
    px: 1.5,
    borderRadius: borderRadius.md,
    transition: transitions.create('background-color', {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    '&:not(:last-child)': {
      mb: 1.25,
    },

    '&.unread': {
      backgroundColor: primary.main,

      '.MuiTypography-root': {
        color: 'white !important',
      },

      '&:hover': {
        backgroundColor: primary.light,
      },
    },

    '&:hover': {
      backgroundColor: light.main,
    },
  };
}

function menuImage(theme) {
  const { borders } = theme;
  const { borderRadius } = borders;

  return {
    display: 'grid',
    placeItems: 'center',

    '& img': {
      width: '100%',
      borderRadius: borderRadius.lg,
    },

    '& .material-icons-round': {
      fontSize: '1.5rem',
    },
  };
}

export { menuItem, menuImage };
